export default "__VITE_ASSET__BIl85i27__"